// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reports hub — keep changes scoped to this page */

.reports-hub {
  margin-top: 67px;
  padding: 0 16px 20px;
  box-sizing: border-box;
}

.reports-hub .headS {
  color: #0f172a;
  margin: 0 0 8px 8px;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.3;
}

.reports-hub .container {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  padding: 0;
  justify-content: center;
  align-items: stretch;
}

.reports-hub .boxSy {
  width: calc(50% - 32px);
  max-width: 320px;
  min-width: 220px;
  min-height: 180px;
  margin: 12px;
  padding: 16px 18px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  cursor: pointer;
  overflow: hidden;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.reports-hub .boxSy:hover {
  transform: translateY(-2px);
  border-color: #cfeaf7;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.reports-hub .boxSy h4 {
  margin: 0 0 6px;
  color: #0f172a;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.35;
}

.reports-hub .boxSy p {
  margin: 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.45;
}

.reports-hub .reportIcon {
  width: 64px;
  height: 64px;
  margin: 0 0 10px;
  padding: 10px;
  stroke-width: 1.5;
  color: #07a6ef;
  background: #eaf7fd;
  border-radius: 10px;
  box-shadow: none;
  flex-shrink: 0;
  transition: background 0.2s ease, color 0.2s ease;
}

.reports-hub .boxSy:hover .reportIcon {
  transform: none;
  color: #0689c5;
  background: #dff2fb;
  box-shadow: none;
}

@media only screen and (max-width: 600px) {
  .reports-hub {
    margin-top: 50px;
    padding: 0 8px 16px;
  }

  .reports-hub .headS {
    font-size: 20px;
    margin-left: 4px;
  }

  .reports-hub .boxSy {
    width: calc(100% - 16px);
    margin: 8px;
    min-height: 0;
  }
}

/* Legacy unused classes kept for safety */
.container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px;
  justify-content: center;
}

.headS {
  color: #333;
  margin: 67px 0 0 25px;
  font-weight: 600;
  font-size: 25px;
}

.boxS,
.boxSS {
  width: calc(50% - 40px);
  max-width: 295px;
  height: 120px;
  margin: 20px;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #ddd;
  cursor: pointer;
}

.boxSy {
  width: calc(50% - 40px);
  max-width: 335px;
  min-height: 180px;
  margin: 16px;
  padding: 10px 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #ddd;
  cursor: pointer;
  overflow: hidden;
  box-sizing: border-box;
}

.boxS:hover,
.boxSS:hover,
.boxSy:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.boxS img {
  width: 55px;
  height: 81px;
  margin-bottom: -16px;
  padding-top: 15px;
}

.boxS p {
  margin-top: -5px;
}

.boxSy p {
  margin: 0;
  font-size: 13px;
  line-height: 1.35;
}

.boxSy h4 {
  margin: 4px 0 8px;
  font-weight: bold;
  font-size: 16px;
}

.boxSS img {
  width: 35px;
  height: 61px;
  margin-bottom: -16px;
  padding-top: 15px;
}

.title {
  font-size: 18px;
  font-weight: bold;
}

.boxS a,
.boxSy a {
  text-decoration: none;
  color: black;
}

.reportIcon {
  width: 74px;
  height: 74px;
  stroke-width: 1.25;
  color: #35aae0;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 18px;
  background: linear-gradient(
    145deg,
    rgba(193, 40, 45, 0.08),
    rgba(193, 40, 45, 0.02)
  );
  box-shadow:
    0 6px 16px rgba(193, 40, 45, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.7);
  transition: all 0.25s ease;
  flex-shrink: 0;
}

.boxSy:hover .reportIcon {
  transform: translateY(-4px) scale(1.06);
  color: #a61f24;
  box-shadow: 0 12px 24px rgba(193, 40, 45, 0.18);
}
`, "",{"version":3,"sources":["webpack://./src/Css/Report.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,UAAU;EACV,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,WAAW;IACX,aAAa;EACf;AACF;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,qDAAqD;EACrD,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,qDAAqD;EACrD,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;EAGE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB;;;;GAIC;EACD;;0CAEwC;EACxC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,+CAA+C;AACjD","sourcesContent":["/* Reports hub — keep changes scoped to this page */\n\n.reports-hub {\n  margin-top: 67px;\n  padding: 0 16px 20px;\n  box-sizing: border-box;\n}\n\n.reports-hub .headS {\n  color: #0f172a;\n  margin: 0 0 8px 8px;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 1.3;\n}\n\n.reports-hub .container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  padding: 0;\n  justify-content: center;\n  align-items: stretch;\n}\n\n.reports-hub .boxSy {\n  width: calc(50% - 32px);\n  max-width: 320px;\n  min-width: 220px;\n  min-height: 180px;\n  margin: 12px;\n  padding: 16px 18px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  cursor: pointer;\n  overflow: hidden;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.reports-hub .boxSy:hover {\n  transform: translateY(-2px);\n  border-color: #cfeaf7;\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);\n}\n\n.reports-hub .boxSy h4 {\n  margin: 0 0 6px;\n  color: #0f172a;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 1.35;\n}\n\n.reports-hub .boxSy p {\n  margin: 0;\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.reports-hub .reportIcon {\n  width: 64px;\n  height: 64px;\n  margin: 0 0 10px;\n  padding: 10px;\n  stroke-width: 1.5;\n  color: #07a6ef;\n  background: #eaf7fd;\n  border-radius: 10px;\n  box-shadow: none;\n  flex-shrink: 0;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.reports-hub .boxSy:hover .reportIcon {\n  transform: none;\n  color: #0689c5;\n  background: #dff2fb;\n  box-shadow: none;\n}\n\n@media only screen and (max-width: 600px) {\n  .reports-hub {\n    margin-top: 50px;\n    padding: 0 8px 16px;\n  }\n\n  .reports-hub .headS {\n    font-size: 20px;\n    margin-left: 4px;\n  }\n\n  .reports-hub .boxSy {\n    width: calc(100% - 16px);\n    margin: 8px;\n    min-height: 0;\n  }\n}\n\n/* Legacy unused classes kept for safety */\n.container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 20px;\n  justify-content: center;\n}\n\n.headS {\n  color: #333;\n  margin: 67px 0 0 25px;\n  font-weight: 600;\n  font-size: 25px;\n}\n\n.boxS,\n.boxSS {\n  width: calc(50% - 40px);\n  max-width: 295px;\n  height: 120px;\n  margin: 20px;\n  padding: 20px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid #ddd;\n  cursor: pointer;\n}\n\n.boxSy {\n  width: calc(50% - 40px);\n  max-width: 335px;\n  min-height: 180px;\n  margin: 16px;\n  padding: 10px 20px;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid #ddd;\n  cursor: pointer;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.boxS:hover,\n.boxSS:hover,\n.boxSy:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.boxS img {\n  width: 55px;\n  height: 81px;\n  margin-bottom: -16px;\n  padding-top: 15px;\n}\n\n.boxS p {\n  margin-top: -5px;\n}\n\n.boxSy p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.boxSy h4 {\n  margin: 4px 0 8px;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.boxSS img {\n  width: 35px;\n  height: 61px;\n  margin-bottom: -16px;\n  padding-top: 15px;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.boxS a,\n.boxSy a {\n  text-decoration: none;\n  color: black;\n}\n\n.reportIcon {\n  width: 74px;\n  height: 74px;\n  stroke-width: 1.25;\n  color: #35aae0;\n  margin-bottom: 10px;\n  padding: 10px;\n  border-radius: 18px;\n  background: linear-gradient(\n    145deg,\n    rgba(193, 40, 45, 0.08),\n    rgba(193, 40, 45, 0.02)\n  );\n  box-shadow:\n    0 6px 16px rgba(193, 40, 45, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.7);\n  transition: all 0.25s ease;\n  flex-shrink: 0;\n}\n\n.boxSy:hover .reportIcon {\n  transform: translateY(-4px) scale(1.06);\n  color: #a61f24;\n  box-shadow: 0 12px 24px rgba(193, 40, 45, 0.18);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
